import {MainFilterItem} from './MainFilterItem';

export const MAIN_FILTER_ITEMS: Array<MainFilterItem> = [
    {
        label: 'Region',
        key: 'region',
        type: 'dropdown',
        tooltip: 'Please select a region',
        selected: {
            label: 'North America',
            value: 'NA'
        },
        options: [
            {
                label: 'North America',
                value: 'NA'
            },
            {
                label: 'GLOBAL',
                value: 'GLOBAL'
            }
        ],
        lockedIfFreemiumNotFollowing: true
    },
    {
      label: 'Country',
      key: 'country',
      type: 'dropdown-search',
      tooltip: 'Upgrade required',
      selected: {
        label: 'All Countries',
        value: 'GLOBAL'
      },
      options: [
        {
          label: 'All Countries',
          value: 'GLOBAL'
        }
      ]
    },
    {
        label: 'Device',
        key: 'device',
        type: 'dropdown',
        tooltip: 'Upgrade required',
        selected: {
            label: 'Smartphone',
            value: 'smartphone'
        },
        options: [
            {
                label: 'Smartphone',
                value: 'smartphone'
            },
            {
                label: 'Tablet',
                value: 'tablet'
            }
        ],
        lockedIfFreemiumNotFollowing: true
    },
    {
        label: 'Month',
        key: 'month',
        type: 'dropdown',
        tooltip: 'Upgrade required',
        selected: null,
        options: null
    }
];
